export const contactsData = {
  email: "rajendra.yadaav24@gmail.com",
  phone: "+917001593600",
  address: "Asansol, West Bengal, India - 713362 ",

  sheetAPI: "https://sheetdb.io/api/v1/q68tdo6gzx970",
};
